export default "__VITE_ASSET__DWj8HDw$__"